import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';

const CustomModal = ({
  id = null,
  show = false,
  dialogClassName = '',
  size = 'lg',
  showCloseButton = true,
  title = '',
  body = null,
  footer = null,
  handleClose = () => {},
  headerStyle,
  backdrop = true,
  keyboard = true,
}) => {

  const renderContent = content => {
    return content && typeof content === 'function' ? content() : content;
  };

  return (
    <Modal
      id={id}
      show={show}
      onHide={handleClose}
      size={size}
      dialogClassName={dialogClassName}
      backdrop={backdrop}
      keyboard={keyboard}
    >
      <Modal.Header style={headerStyle} closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{renderContent(body)}</Modal.Body>
      {footer && <Modal.Footer>{renderContent(footer)}</Modal.Footer>}
    </Modal>
  );
};

CustomModal.propTypes = {
  id: PropTypes.string,
  show: PropTypes.bool,
  dialogClassName: PropTypes.string,
  size: PropTypes.string,
  showCloseButton: PropTypes.bool,
  title: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  footer: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  handleClose: PropTypes.func,
  headerStyle: PropTypes.object,
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  keyboard: PropTypes.bool,
};

export default CustomModal;
